import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmark.svg';

export const IconBookmark = createIconComponent(Icon);
